import {RouteDefinition} from '../../../routes';
import {InputTypeListScreen} from './InputTypeListScreen';

export const InputTypeSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/developer/input-type',
        component: InputTypeListScreen,
    },
];
